import { selectBasket, sendBasket, updatePaymentInProgress } from 'containers/OrderDetails/basketSlice'
import { selectUserId } from 'containers/Login/loginSlice'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { LOCATION_STATES } from 'utils/constants'
import { POST } from 'rest/request'
import * as urls from 'rest/urls'
import { v7 } from 'uuid'

const usePaymentProcessing = (selected, isLoading, setLoading) => {
  const { cartId, checkout, invoice, newDocuments } = useSelector(selectBasket)
  const userId = useSelector(selectUserId)

  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const { replace, push } = useHistory()

  const getPayment = (newDocumentsResponse) => {
    const payment = {
      amount: (newDocumentsResponse?.checkout || checkout)?.to_pay?.now?.grossPrice,
      methodId: selected.methodId,
      date: 'now'
    }
    if (selected.optionId) {
      payment.optionId = selected.optionId
    }
    return payment
  }

  const callback = (payment) => {
    if (payment) {
      dispatch(sendBasket({ step: 'finalize', payments: [payment] })).then(res => {
        if (res.payload?.sold) {
          replace('/newwarehouse')

        } else if (res.payload?.locked) {
          replace(`/payment/status?paymentId=${payment.remotePaymentId}`)

        } else {
          setLoading(false)
        }
      })

    } else {
      setLoading(false)
    }
  }

  const generateBody = (localPaymentId, code, newDocumentsResponse) => {
    const body = {
      userId,
      cartId,
      action: 'payment',
      invoices: (newDocumentsResponse?.newDocuments || newDocuments).map(({ id, toPay }) => ({ invoiceId: id, amount: toPay }))
    }

    if (invoice) {
      body.companyNIP = invoice.nip
    }

    const payment = getPayment(newDocumentsResponse)
    payment.localPaymentId = localPaymentId
    if (code) {
      payment.code = code
    }
    payment.init = true
    body.payments = [payment]

    return body
  }

  const initOnlinePayment = async (newDocumentsResponse) => {
    const body = generateBody(v7(), '', newDocumentsResponse)
    if (!body) return
    const response = await POST(urls.paymentSettlement, { body })
    if (response?.url) {
      dispatch(updatePaymentInProgress(true))
      window.open(response.url, '_self')
      setTimeout(() => {
        setLoading(false)
      }, 500)

    } else {
      console.error('Coś poszło nie tak...')
      setLoading(false)
    }
  }

  const purchase = async () => {
    if (isLoading) return
    setLoading(true)
    const payment = getPayment()
    const blikId = checkout.payments.find(p => p.key === 'blik')?.id
    dispatch(sendBasket({ step: 'newDocument', payments: [payment] })).then(res => {
      if (res.payload?.newDocuments) {
        switch (payment.methodId) {
          case blikId:
            push(pathname, LOCATION_STATES.popup({ type: 'blik', payment }))
            break

          default:
            initOnlinePayment(res.payload)
        }

      } else {
        setLoading(false)
      }
    })
  }

  return {
    purchase,
    generateBody,
    callback
  }
}

export default usePaymentProcessing